import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { columnHeaderTranslations } from '@marketiq/marketiq-core-data';
import enTranslation from './locales/en/translation.json';
import deTranslation from './locales/de/translation.json';
import esTranslation from './locales/es/translation.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        ...enTranslation,
        columnHeaders: columnHeaderTranslations.en,
      },
    },
    de: {
      translation: {
        ...deTranslation,
        columnHeaders: columnHeaderTranslations.de,
      },
    },
    es: {
      translation: {
        ...esTranslation,
        columnHeaders: columnHeaderTranslations.es,
      },
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
